export const GET_FILES_ASYNC = 'GET_FILES_ASYNC'
export const POST_FILES_ASYNC = 'POST_FILES_ASYNC'
export const DOWNLOAD_FILE_ASYNC = 'DOWNLOAD_FILE_ASYNC'

export const MOCK_POST_FILE_ASYNC = 'MOCK_POST_FILE_ASYNC'